import { ethers } from "ethers";
import Contract from "../context/NftMarketPlace.json";

async function deployContract() {
    try {
        if (!window.ethereum) {
            throw new Error("MetaMask is not installed.");
        }
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner();
        const contractFactory = new ethers.ContractFactory(Contract.abi, Contract.bytecode, signer);
        const deployedContract = await contractFactory.deploy();
        await deployedContract.deploymentTransaction().wait();
        const contractAddress = deployedContract.getAddress();
        // console.log("Contract deployed at contractAddress:", contractAddress);

        return deployedContract;
    }
    catch (error) {
        return error;
    };
};

export {
    deployContract,
};
